import {restfulClient,actionClient} from "@/api";
import {formatParams} from "@/helpers";

const inventedUrl = '/gift-order/invented-order'
const entityUrl = '/gift-order/entity-order'
const expressInfoUrl = '/express-code'
const entityOrderShippedUrl = '/gift-order/entity-order-shipped/'
export const downloadShippedTemplateUrl = 'gift-order/entity-order-shipped-export'
export const importShippedUrl = 'gift-order/entity-order-shipped-import'
export const exportUrl = 'gift-order/order-export';

export function getInventedList(searchForm) {
    return restfulClient.getCollection(inventedUrl, formatParams(searchForm))
}

export function getInvented(id) {
    return restfulClient.getDocument(inventedUrl, id, ['gift.category'])
}

export function getEntityList(searchForm) {
    return restfulClient.getCollection(entityUrl, formatParams(searchForm))
}

export function getEntity(id) {
    return restfulClient.getDocument(entityUrl, id, ['gift.category'])
}

export function getExpressInfo() {
    return actionClient.get(expressInfoUrl)
}

export function entityOrderShipped(shippedForm) {
    return actionClient.update(entityOrderShippedUrl+shippedForm.id,{...shippedForm})
}